import styled from '@emotion/styled'
import { Box } from '@mui/material'
import React from 'react'
import { THorse } from '../../shared/types/horse.type'
import { upperCase } from 'lodash'

type HorseHierarchyProps = {
  horse?: THorse
}

function Hierarchy({ horse }: HorseHierarchyProps) {
  return (
    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} position={'relative'} >
      <p style={{ fontSize: '12px' }}>{upperCase(horse?.name)}</p>
      <div id='hirearchy' ></div>
      <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
        <div className='childText'>{upperCase(horse?.mother_name)}
          {
            horse?.father_mother_name && <>
              <div id='hirearchy' ></div>
              <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
                <p className='childText'></p>
                <p className='childText rightItem'>{upperCase(horse?.father_mother_name)}</p>
              </Box>
            </>
          }

        </div>
        <p className='childText rightItem'>{upperCase(horse?.father_name)}</p>
      </Box>
    </Box>
  )
}


export default Hierarchy